import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import AuthUser from "../Loji/loji"; 

const AcademicInformation = ({ formData, setFormData, nextStep, prevStep }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSocialSciencesPopup, setShowSocialSciencesPopup] = useState(false);
  const [eligibleForScholarship, setEligibleForScholarship] = useState(true);
  const [universities, setUniversities] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const { http } = AuthUser();
  
  const SEEF_UNIVERSITIES = "universities";
  const SEEF_DISCIPLINES = "disciplines";
  // const SEFF_ACADEMIC = 'academics'; 
  const navigate = useNavigate(); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const universitiesResponse = await http.get(SEEF_UNIVERSITIES);
        setUniversities(universitiesResponse.data);

        const disciplinesResponse = await http.get(SEEF_DISCIPLINES);
        setDisciplines(disciplinesResponse.data);
      } catch (error) {
        console.error("Error fetching universities or disciplines:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    // GPA اور Percentage کے لیے لاجک
    if (name === "gpa" || name === "percentage") {
      updatedValue = value.replace(/[^\d.]/g, "");
      const decimalIndex = updatedValue.indexOf(".");
      if (decimalIndex !== -1) {
        updatedValue = updatedValue.slice(0, decimalIndex + 3);
      } else {
        updatedValue = updatedValue.slice(0, 3);
      }
    }

    // Years (Registration & Admission) کے لیے خاص کنٹرول
    if (name === "registrationYear" || name === "yearOfAdmission") {
      // صرف ہندسوں (Digits) کو رکھو، باقی سب ختم کر دو
      const digitsOnly = value.replace(/\D/g, "");
      
      // پہلا ہندسہ لازمی '2' ہونا چاہیے
      if (digitsOnly.length > 0 && !digitsOnly.startsWith("2")) {
        return; 
      }
      // دوسرا ہندسہ لازمی '0' ہونا چاہیے
      if (digitsOnly.length > 1 && !digitsOnly.startsWith("20")) {
        return; 
      }
      
      // زیادہ سے زیادہ 4 ہندسوں کی اجازت دو
      updatedValue = digitsOnly.slice(0, 4);
    }

    if (name === "gradeSystem") {
      setFormData({ ...formData, gpa: "", percentage: "", gradeSystem: value });
    } else {
      setFormData({ ...formData, [name]: updatedValue });
    }
  };

  const validate = () => {
    const newErrors = {};
    const currentYear = new Date().getFullYear();

    if (!formData.discipline) {
      newErrors.discipline = "Discipline is required";
    }

    if (formData.applyAs === "Fresh Candidate") {
      if (!formData.registrationNumber) {
        newErrors.registrationNumber = "Registration Number is required";
      }
      
      // Year of Registration Validation
      if (!formData.registrationYear) {
        newErrors.registrationYear = "Year of Registration is required";
      } else if (formData.registrationYear.length !== 4) {
        newErrors.registrationYear = "Enter a complete 4-digit year";
      } else if (formData.registrationYear > currentYear) {
        newErrors.registrationYear = `Year cannot be greater than ${currentYear}`;
      }

      // Year of Admission Validation
      if (!formData.yearOfAdmission) {
        newErrors.yearOfAdmission = "Year of Admission is required";
      } else if (formData.yearOfAdmission.length !== 4) {
        newErrors.yearOfAdmission = "Enter a complete 4-digit year";
      } else if (formData.yearOfAdmission > currentYear) {
        newErrors.yearOfAdmission = `Year cannot be greater than ${currentYear}`;
      }

      if (!formData.universityName) {
        newErrors.universityName = "University / Institute is required";
      }
      if (!formData.gradeSystem) {
        newErrors.gradeSystem = "Grade System is required";
      }
      if (formData.gradeSystem === "GPA" && !formData.gpa) {
        newErrors.gpa = "GPA is required";
      }
      if (formData.gradeSystem === "Percentage" && !formData.percentage) {
        newErrors.percentage = "Percentage is required";
      }
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      setIsSubmitting(false);
      nextStep(); 
    } catch (error) {
      console.error("Error while submitting data:", error);
      setIsSubmitting(false);

      if (error.response && error.response.data && error.response.data.errors) {
        setErrors(error.response.data.errors);
      } else {
        setErrors({
          general: "Something went wrong. Please try again later.",
        });
      }
    }
  };

  const handleDisciplineChange = async (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setUniversities([]);

    if (value === "NURSING") {
      setUniversities([
        "CHANDKA MEDICAL COLLEGE, LARKANA",
        "DOW UNIVERSITY OF HEALTH SCIENCES (DUHS), KARACHI",
        "GAMBAT INSTITUTE OF MEDICAL SCIENCES, KHAIRPUR",
        "GHULAM MUHAMMAD MEHER MEDICAL COLLEGE, SUKKUR",
        "JINNAH SINDH MEDICAL UNIVERSITY (JSMU), KARACHI",
        "KARACHI MEDICAL AND DENTAL COLLEGE, KARACHI",
        "KHAIRPUR MEDICAL COLLEGE, KHAIRPUR",
        "LIAQUAT UNIVERSITY OF MEDICAL & HEALTH SCIENCES (LUMHS), JAMSHORO",
        "PEOPLES UNIVERSITY OF MEDICAL & HEALTH SCIENCES FOR WOMEN, SHAHEED BENAZIRABAD",
        "SHAHEED BENAZIR BBUTTO MEDICAL UNIVERSITY, LIYARI, KARACHI",
        "THAR INSTITUTE OF NURSING AND ALLIED HEALTH SCIENCES"
      ]);
    } else {
      try {
        const universitiesResponse = await http.get(SEEF_UNIVERSITIES);
        setUniversities(universitiesResponse.data);
      } catch (error) {
        console.error("Error fetching universities:", error);
      }
    }

    if (value === "SOCIAL SCIENCE") {
      setShowSocialSciencesPopup(true);
    } else {
      setShowSocialSciencesPopup(false);
    }
  };

  const handleSocialSciencesPopupResponse = (response) => {
    setShowSocialSciencesPopup(false);
    if (response === "yes") {
      setEligibleForScholarship(true);
    } else {
      setEligibleForScholarship(false);
      window.alert("Sorry You Are not Eligible for Scholarship");
      window.open("https://seef.sindh.gov.pk/", "_blank"); 
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2 className="text-2xl font-bold mb-6">Academic Information</h2>

      <div className="mb-4">
        <label className="block text-lg font-semibold text-gray-700">
          Apply As
        </label>
        <select
          name="applyAs"
          value={formData.applyAs || ""}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded-md"
        >
          <option value="">Select Apply As</option>
          <option value="Fresh Candidate">Fresh Candidate</option>
        </select>
        {errors.applyAs && (
          <p className="text-red-500 text-sm">{errors.applyAs}</p>
        )}
      </div>

      {formData.applyAs === "Fresh Candidate" && (
        <>
          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              University Registration Number
            </label>
            <input
              type="text"
              name="registrationNumber"
              value={formData.registrationNumber || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md"
            />
            {errors.registrationNumber && (
              <p className="text-red-500 text-sm">
                {errors.registrationNumber}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              Year of Registration
            </label>
            <input
              type="text"
              name="registrationYear"
              placeholder="20XX"
              value={formData.registrationYear || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md"
            />
            {errors.registrationYear && (
              <p className="text-red-500 text-sm">
                {errors.registrationYear}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              Year of Admission
            </label>
            <input
              type="text"
              name="yearOfAdmission"
              placeholder="20XX"
              value={formData.yearOfAdmission || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md"
            />
            {errors.yearOfAdmission && (
              <p className="text-red-500 text-sm">{errors.yearOfAdmission}</p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              Discipline
            </label>
            <select
              name="discipline"
              value={formData.discipline || ""}
              onChange={handleDisciplineChange}
              className="w-full px-4 py-2 border rounded-md"
            >
              <option value="">Select Discipline</option>
              {/* <option value="pharmacy">Pharmacy</option> */}
              {disciplines.map((discipline) => (
                <option key={discipline} value={discipline}>
                  {discipline}
                </option>
              ))}
            </select>
            {errors.discipline && (
              <p className="text-red-500 text-sm">{errors.discipline}</p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              University / Institute
            </label>
            <select
              name="universityName"
              value={formData.universityName || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md"
            >
              <option value="">Select University / Institute</option>
              {/* <option value="abc">abc</option> */}
              {universities.map((university) => (
                <option key={university} value={university}>
                  {university}
                </option>
              ))}
            </select>
            {errors.universityName && (
              <p className="text-red-500 text-sm">{errors.universityName}</p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-semibold text-gray-700">
              Grade System
            </label>
            <select
              name="gradeSystem"
              value={formData.gradeSystem || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md"
            >
              <option value="">Select Grade System</option>
              <option value="GPA">GPA</option>
              <option value="Percentage">Percentage</option>
              <option value="FirstYearStudent">First Year</option>
            </select>
            {errors.gradeSystem && (
              <p className="text-red-500 text-sm">{errors.gradeSystem}</p>
            )}
          </div>

          {formData.gradeSystem === "GPA" && (
            <div className="mb-4">
              <label className="block text-lg font-semibold text-gray-700">
                GPA
              </label>
              <input
                type="text"
                name="gpa"
                value={formData.gpa || ""}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-md"
              />
              {errors.gpa && (
                <p className="text-red-500 text-sm">{errors.gpa}</p>
              )}
            </div>
          )}

          {formData.gradeSystem === "Percentage" && (
            <div className="mb-4">
              <label className="block text-lg font-semibold text-gray-700">
                Percentage
              </label>
              <input
                type="text"
                name="percentage"
                value={formData.percentage || ""}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-md"
              />
              {errors.percentage && (
                <p className="text-red-500 text-sm">{errors.percentage}</p>
              )}
            </div>
          )}
        </>
      )}

      {showSocialSciencesPopup && (
        <div className="mb-4 bg-gray-100 p-4 rounded-md">
          <p className="text-gray-700 mb-2">
            Are you a student of BS (Social Sciences) or any other subject of the Social Sciences category?
          </p>
          <div className="flex gap-2">
            <button
              type="button"
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
              onClick={() => handleSocialSciencesPopupResponse("yes")}
            >
              Social Sciences
            </button>
            <button
              type="button"
              className="px-4 py-2 bg-gray-500 text-white rounded-md"
              onClick={() => handleSocialSciencesPopupResponse("no")}
            >
              Other Subject
            </button>
          </div>
        </div>
      )}

      {errors.general && (
        <p className="text-red-500 text-sm mb-4">{errors.general}</p>
      )}

      <div className="flex justify-between mt-6">
        <button
          type="button"
          onClick={prevStep}
          className="px-4 py-2 bg-gray-500 text-white rounded-md"
        >
          Previous
        </button>
        <button
          type="submit"
          className={`px-4 py-2 ${isSubmitting ? "bg-gray-400" : "bg-blue-500"} text-white rounded-md`}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Next"}
        </button>
      </div>
    </form>
  );
};

export default AcademicInformation;